var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import * as $ from "jquery";
import { parse } from "query-string";
import { SET_TREATMENT_VARIABLE, NO_CHROME, WORKSPACE_ID, PREPROD_ENVIRONMENT, BRANCH_NAME_FIELD, BASE_URL_FIELD, VERSION_FIELD, BST_CUSTOM_BUILD } from "../constants/QueryString.constants.js";
import { EXP_HOSTNAME, BCT_LOCAL_HOSTNAME, LOCAL_ORIGIN } from "../host/Host.constants.js";
import { isIFrame, isExpUIHostOrigin } from "../host/Host.utilities.js";
import { HostService } from "./HostService.js";
import { isRelativeUrl } from "../utils/UrlUtils.js";
import { buildOdataQuery } from "../utils/ODataUtils.js";
import fetch from "fetch-retry";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
const ROOT_BLOB_ASSET_URL = "https://expassetsprod.blob.core.windows.net";
const MSFT_SUBSCRIPTION_ID_PROD = "dad45786-32e5-4ef3-b90e-8e0838fbadb6";
const MSFT_WORKSPACE_ID_PROD = "a5766fee-9478-488b-9fc0-64d1ad72c290";
const MSFT_WORKSPACE_ID_A11YVCURRENT = "447d2216-9665-49f8-a1ba-7503a8dcb4a3";
const MSFT_WORKSPACE_ID_LOCAL = "19dd1388-c672-456c-b50b-1144c3bdd347";
const MSFT_NEW_WORKSPACE_ID_LOCAL = "881d3c59-3d4a-42e7-9fd3-9223181b7f8a";
const AZURE_TEST_WORKSPACE_ID = "d0b5adff-df5f-4199-bdd9-31b28eb33507";
const AZURE_NEW_TEST_WORKSPACE_ID = "c390c3c2-a5a9-459b-bbf4-dda71155f4ec";
const MSFT_EG_ROOT = "microsoft";
const MSFT_WORKSPACE_NAME_PROD = "msft";
const MSFT_WORKSPACE_NAME_LOCAL = "testmsft";
const MSFT_NEW_WORKSPACE_NAME_LOCAL = "testmsft72f";
const OPG_WORKSPACE_ID = "13273047-d2c3-4185-9022-76fc5fc6742a";
const METRICSAUTHORINGOPTINLEVEL = {
  Legacy: 0,
  OptIn: 10,
  OptInWarning: 20,
  OptOut: 30,
  DisableOptOut: 40,
  New: 50
};
const PREVIEWSCORECARDOPTINLEVEL = {
  OptIn: 10,
  OptOut: 20,
  DisableOptOut: 30
};
const AZUREEXPROLLOUTOPTINLEVEL = {
  OptIn: 10,
  OptOut: 20,
  DisableOptOut: 30
};
const defaultTreatmentVariables = {
  useEnv: "",
  enableWorkspaceMismatchPage: false,
  /**
   * Workspace migration
   */
  wsplitEnableRedirects: false,
  wsplitEnableNonMSFTRedirects: false,
  enableWorkspaceSplitTesting: false,
  wsplitExpManGenericRedirects: false,
  wsplitGetMigrationDataByWsid: false,
  wsplitEnableWSAutoPopulate: false,
  wsplitMigrationEmail: "",
  wsplitMigrationDate: "",
  wsplitPendingMigrationBannerText: "",
  wsplitMigratingBannerText: "",
  wsplitRedirectBannerText: "",
  wsplitMethodNotAllowedText: "",
  wsplitNotAcceptableText: "",
  wsplitDeprecateUsingTid: false,
  // testing
  wsplitReadOnly: false,
  wsplitCannotUpdate: false,
  wsplitReturn301: false,
  wsplitRedirectWorkspaceId: "",
  // additional treatments
  xCardMovePFilters: false,
  xCardResponsiveToggle: false,
  scorecardTableOptInLevel: 0,
  xCardDisableLegacyTable: false,
  EnableXCardNotebookExtension: false,
  EnableEmptyScorecardDebugger: false,
  EnableXBoxGamingExtension: false,
  EnableAbstractExtension: false,
  EnableInteractiveDebugging: false,
  EnableMetricPowerExtension: false,
  EnableArenaExtension: false,
  EnableArenaExposure: false,
  EnableEdgeExtension: false,
  EnableTitanQueryParamSlug: false,
  EnableTitanInUTC: false,
  EnableTitanNativeFilters: false,
  EnablexCardExtension: false,
  EnableXCardTitanExtensionV2: false,
  EnableCatapultReviewExtension: false,
  hideLegacyCreateFlightbyMG: false,
  deprecatedBctPaths: "",
  linkRouteActionForSearchMode: "",
  showExperimentRouteViews: false,
  useProgressionUpdateFormik: false,
  ShowUnifiedStudioAlerts: false,
  SetIFrameUrl: false,
  EnableUnifiedViewIsolationGroupMultiSelection: false,
  ShowUnifiedViewReRandomizeCheckBox: false,
  enableBatchAlertsAPICall: false,
  loadSingleStageAlerts: false,
  deprecateLegacyAlertUX: false,
  showBlueshiftCMSUI: false,
  logSetUser: false,
  enableNewScorecardTemplate: false,
  releaseDSMSdataprofiling: false,
  enableAnalysisLinkDropdown: false,
  analysisHubTimeout: 1e3,
  garAnalysisHubLoadAlerts: false,
  garAnalysisHubHideEmptyScorecards: false,
  analysisHubPriority: false,
  EnableStudyTaskPivot: false,
  xCardLinkIndex: 0,
  guidedLinkIndex: 1,
  allScorecardsLinkIndex: 2,
  xCardLinkString: "xCard",
  guidedLinkString: "Guided",
  allScorecardsLinkString: "All scorecards",
  a11yProgressionNameTextFieldContrast: false,
  enableProgressionStageControlCorrection: false,
  useAPIMVCurrentExpManURL: false,
  enableOverridesTrafficEditV2: false,
  enableTreatmentVariableExperience: false,
  testUpdatedProgressionsCall: false,
  updateAssignmentInconsistencyForTransfer: false,
  addGroupTemplateSelectFeature: false,
  useUpdatedFeatureXCardLink: false,
  enableBudgetPagePriority: false,
  enableIsolationGroupManagementPriority: false,
  enableNoStepsInStageFix: false,
  useIgDisplayNameExperimentCreate: false,
  updateTVNameLengthLimit: 90,
  enableTransferWarningConflictFix: false,
  displayFriendlyValidationMessageForDSMSHistory: false,
  includeCompleteResponseInRestResult: false,
  showDifferentProgressionFeaturesOnVNext: false,
  useNewSectionBox: false,
  useNewFlightListViewer: false,
  enableSubClusterA11yUpdate: false,
  useOnlyMySubscribedInititialState: false,
  useRTKQueryFeatureSearch: false,
  replaceCTSearchView: false,
  optInWsIdToNewFeatureSearch: "",
  enableAzureExpAutoTriggeringUX: false,
  enableClearFiltersButton: false,
  callXCardApiCommonInfra: false,
  // These flights are not needed and should be removed
  // The code that requires these flights should be hard-coded,
  // or otherwise refactored.
  // The default values are now set to fully rolled out
  enableFilterValueValidation: false,
  enableTreatmentVariableNamespaceEdit: false,
  enableProgressionBulkEdit: false,
  enableHypothesisInStudio: false,
  disableMsalInPopupLogProvider: false,
  showMMPivot: false,
  showFilterbar: false,
  showCIPlot: false,
  parallelSRMWarning: false,
  enableInterleaving: false,
  forceUnifiedView: false,
  forceControlTower: false,
  enableStudioFeatureHistory: false,
  useTraditionalFeatureListInUnifiedView: false,
  fixDisableAutoshutdown: false,
  showAdvanceSearchInUnifiedView: false,
  allowUnifiedSearchDateFilter: false,
  showAdminPortalInUnifiedView: false,
  optInWsIdToUnifiedView: "",
  doNotLoadMSFTWorkspaceData: false,
  enableFlashResaltWarning: false,
  enableMetricSetDelete: false,
  useFluentDatePicker: false,
  enableVCurrentWPS: false,
  vivaceiframeoptinlevel: METRICSAUTHORINGOPTINLEVEL.New,
  vivaceiframeoptindefaultdate: "10/03/2022",
  vivaceiframeoptindeprecateddate: "11/01/2022",
  enableHelpMessageBar: false,
  enableBlueShiftOverride: false,
  enableHelpImagePreview: false,
  enableIsolationGroupManagement: false,
  useWPSProxy: false,
  enableNewEnvFlag: false,
  useNewAddAnalysisPanel: false,
  enableAutoTriggerToggle: false,
  defaultAutoTriggerState: false,
  enableExPCopilot: false,
  enableExPCopilotHelpPageOnly: false,
  getGatingTenantFromMigrationRecord: false,
  enableSyncedMetricSetPermissionWorkflow: false,
  enableSyncedMetricSetCreateWorkflow: false,
  openFeatureInSameTab: false,
  enableAAStream: false,
  enableRequiredMDSFiltersValidation: false,
  showAssignmentUnitId: false,
  enableUnifiedAPIOfSubscribeMode: false,
  fixLayoutScrollbars: false,
  enableCMSUnifiedApi: false,
  enableRefactoredWSSelection: false,
  filterNonCompatMgsFromSearch: false,
  enableAnalysisCreateSubscriberComponent: false,
  useCMSThroughFEProxy: false,
  enableNewPreviewScorecardPage: true,
  enableMetricsWizard: false,
  enableMetricsWizardTesting: false,
  enableMetricsWizardFilters: false,
  enableMetricsWizardRawMode: false,
  enableMetricsWizardCustomDim: false,
  enableMetricsWizardIfElse: false,
  enableMetricsWizardInternalNameCheck: false,
  enableMetricCreationViaTemplate: false,
  enableNewCreateCustomColumnView: false,
  enableNewCreateCustomColumnViewTesting: false,
  disableMetricsWizardExperienceCheck: false,
  useNewSegmentsUI: false,
  useNewMergeErrorPanel: false,
  previewScorecardOptinLevel: PREVIEWSCORECARDOPTINLEVEL.OptOut,
  previewScorecardOptInDefaultDate: "April 11th 2024",
  previewScorecardOptInDeprecatedDate: "January 31st 2025",
  enableProgressionTemplates: false,
  disableLegacyProgressionCreateInStudio: false,
  enableHypothesisTemplateFiltering: false,
  enableUnifiedNoCacheMiddleware: false,
  enableEgSelectionInAuManagement: false,
  enableEgSelectionInIgManagement: false,
  enableMSIForCMS: false,
  enableMSIForDSMS: false,
  useMgFormatInOperationCheckMarkdown: false,
  enableEgSelectionInAfManagement: false,
  previewScorecardSearchCountLegacy: 2e3,
  previewScorecardSearchCountUnified: 100,
  enableSampleDataSource: false,
  quickValidateMetricsetAllowList: "",
  useXCardThroughFEProxy: false,
  updateArenaText: false,
  redirectAzureExpFeature404s: false,
  enableNewMDLPollingPolicy: false,
  enableMoreColumnsOnFeatureListPage: false,
  useFalseForOnlyLoadFeatureData: false,
  EnableQuickValidationByWorkspace: false,
  enableTimeZoneFeature: false,
  enableSRMDebugEnhancements: false,
  useLatestUnifiedApiVersion: false,
  enableProgressionStageAlertImprovements: false,
  enableMergePublishTimeout: false,
  showDetailedTaskState: false,
  disableCreateAnalysisOnDataCollection: false,
  waitForPublishSubmissionToLoadStatus: false,
  enableExperimentationGroupLevelPermissions: false,
  enableIApiErrorExceptionHandlingToCT: false,
  enableAnalysisTemplateVersionLinkFix: false,
  enableShadowExperiment: false,
  enableASSelectionInIgManagement: false,
  enableStudioAssignmentInconsistency: false,
  excludeFeatureTypeFromMetadataQuery: false
};
const treatmentVariable = (type) => {
  return (target, propertyKey, descriptor) => {
    const originalMethod = descriptor.value;
    descriptor.value = function(...args) {
      var _a;
      const svc = this;
      const overrideParam = svc.getQueryParam(SET_TREATMENT_VARIABLE);
      if (overrideParam) {
        const prefix = `${propertyKey}:`;
        const variables = overrideParam.split("|");
        const targetOverride = variables.find((item) => item.indexOf(prefix) === 0);
        if (targetOverride) {
          const value = targetOverride.substr(prefix.length);
          return type === "boolean" ? value == "true" : type === "number" ? +value : value;
        }
      }
      const tvar = (_a = svc.config.treatmentVariables) == null ? void 0 : _a[propertyKey];
      return !!svc.config.treatmentVariables && tvar !== void 0 ? tvar : originalMethod.apply(this, args);
    };
  };
};
class EnvironmentService {
  constructor() {
    __publicField(this, "onUserChangedCallback", []);
    __publicField(this, "_documentTitle", "");
    /**
     * Determines whether the Unified experience should be used. This is set on load by the RenderExperience
     * based on workspace information and then is read throughout the application after initial load.
     */
    __publicField(this, "_isUnifiedView", false);
    __publicField(this, "config", {
      assetUrl: "/",
      version: "local",
      debug: this.isLocal,
      user: null,
      host: this.getQueryParam("host"),
      test: false,
      treatmentVariables: null,
      isPreRelease: true,
      wpsStatus: null
    });
  }
  get endpoints() {
    return HostService.endpoints;
  }
  get armResourceEndpoint() {
    return "https://management.azure.com/providers/Microsoft.ResourceGraph";
  }
  get azureActiveDirectory() {
    return {
      clientId: HostService.clientId,
      endpoint: "https://login.windows.net",
      // TODO: set in endpoints.js
      /**
       * https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-client-application-configuration
       * common: Sign in users with work and school accounts or personal Microsoft accounts.
       *
       * Use the common tenantId for the initial authentication flow
       * within handleRedirectPromise we will set and retrieve the logged in users tenantId from local storage
       * until we know the logged in user information we cannot set the tenantId used to get the current user's account
       * Sign in users with work and school accounts or personal Microsoft accounts.
       */
      tenantId: "common"
      // TODO: set in endpoints.js
    };
  }
  getVersion() {
    return this.config.version;
  }
  getWpsStatus() {
    var _a;
    const defaultStatus = {
      wpsWorkspaceId: "",
      needRequestToProxy: false,
      workspaceProxyEnabled: false
    };
    return (_a = this.config.wpsStatus) != null ? _a : defaultStatus;
  }
  setWpsStatus(wpsStatus) {
    this.config.wpsStatus = wpsStatus;
  }
  getBaseUrl() {
    let url = this.config.assetUrl;
    if (!url) {
      return url;
    }
    let pathArr = url.split("/");
    if (pathArr.length <= 3) {
      return url;
    }
    let protocol = pathArr[0];
    let host = pathArr[2];
    return `${protocol}//${host}`;
  }
  get isDebug() {
    return this.config.debug;
  }
  get isIframe() {
    return isIFrame();
  }
  get queryParams() {
    return !!window.location.search ? parse(window.location.search) : {};
  }
  getUnescapedQueryParams() {
    return !!window.location.search ? parse(unescape(window.location.search)) : {};
  }
  getQueryParam(key) {
    if (!key)
      return "";
    const param = this.queryParams[key] || this.queryParams[key.toLowerCase()];
    return this.validateParam(param);
  }
  getLocation() {
    return document.location.href;
  }
  get title() {
    return this._documentTitle;
  }
  set title(title) {
    this._documentTitle = title;
  }
  validateParam(param) {
    if (Array.isArray(param)) {
      if (!param.length)
        return "";
      return param.shift();
    }
    return param;
  }
  setTreatmentQueryParam(key, value, url = window.location.href) {
    const parsed = isRelativeUrl(url) ? new URL(url, "http://dummy.com/") : new URL(url);
    const param = parsed.searchParams.get(SET_TREATMENT_VARIABLE) || "";
    const treatments = __spreadProps(__spreadValues({}, Object.fromEntries(
      param.split("|").filter((x) => !!x).map((t) => t.split(":"))
    )), {
      [key]: value
    });
    return buildOdataQuery(void 0, {
      baseUrl: url,
      additionalQueryParams: {
        [SET_TREATMENT_VARIABLE]: Object.entries(treatments).map(([k, v]) => `${k}:${v}`).join("|")
      }
    });
  }
  removeTreatmentQueryParam(key, url = window.location.href) {
    const isRelative = isRelativeUrl(url);
    const parsed = isRelative ? new URL(url, "http://dummy.com/") : new URL(url);
    const param = parsed.searchParams.get(SET_TREATMENT_VARIABLE) || "";
    const treatments = Object.fromEntries(
      param.split("|").filter((x) => !!x).map((t) => t.split(":")).filter(([k]) => k !== key)
    );
    if (!Object.keys(treatments).length) {
      parsed.searchParams.delete(SET_TREATMENT_VARIABLE);
    } else {
      parsed.searchParams.set(
        SET_TREATMENT_VARIABLE,
        Object.entries(treatments).map(([k, v]) => `${k}:${v}`).join("|")
      );
    }
    let outputParams = {};
    parsed.searchParams.forEach((value, key2) => {
      outputParams[key2] = value;
    });
    return buildOdataQuery(void 0, {
      baseUrl: isRelative ? parsed.pathname : parsed.origin + parsed.pathname,
      additionalQueryParams: outputParams
    });
  }
  /**
   * Determines if we are production code.
   * NOTE: DON'T USE THE FLAG TO CHANGE BUSINESS LOGIC. IT CAN CAUSE SOMETHING TO PASS IN BRANCH LINK WHILE FAIL IN PROD. ONLY USE IT FOR LOGGING ENVIRONMENT
   */
  get isProduction__DontUseForBranchingCode_OnlyUseForLoggingEnvironment() {
    return !this.isLocal && !this.isPreReleaseVersion && document.location.hostname === EXP_HOSTNAME;
  }
  /**
   * Determines if we are serving from self-host
   */
  get isLocal() {
    return this.isLocalOrTest && !!document.location.port;
  }
  /**
   * Determines if we are serving from IIS
   */
  get isLocalExp() {
    return this.isLocalOrTest && document.location.hostname === BCT_LOCAL_HOSTNAME && !document.location.port;
  }
  /**
   * Determines if we are serving from the dev environment locally or from self host
   */
  get isLocalOrTest() {
    return /localhost/.test(document.location.host);
  }
  /**
   * Determines if the assets are originating from localhost domain and we are running in production
   */
  get isLocallyServed() {
    return /localhost/.test(this.config.assetUrl);
  }
  /**
   * Determines if ExP is the Host application
   * Usage - loading ExP UI on a Host origin or no presence of the BCT global g_tvars
   */
  get isExpHost() {
    return isExpUIHostOrigin() || !window["_config"] && !window["g_tvars"];
  }
  get isNoChrome() {
    const noChrome = this.getQueryParam(NO_CHROME);
    return noChrome === "true";
  }
  /**
   * Determines whether the Unified experience should be used.
   */
  get isUnifiedView() {
    return this._isUnifiedView;
  }
  /**
   * Determines if we are "testing" a _branchName or _version
   */
  get isPreReleaseVersion() {
    return this.config.isPreRelease;
  }
  getDisplayVersion() {
    return this.getVersion().replace(/refs\/heads/, "");
  }
  getUser() {
    return this.config.user || { name: "unknown", alias: "unknown", displayName: "unknown", upn: "unknown", email: "unknown" };
  }
  getWorkspaceIdOrDefault(workspaceId = null) {
    if (!!workspaceId) {
      return workspaceId.toLocaleLowerCase();
    }
    const workspaceQueryParam = this.getQueryParam(WORKSPACE_ID);
    if (!!workspaceQueryParam) {
      return workspaceQueryParam.toLocaleLowerCase();
    }
    return this.getMsftWorkspaceId();
  }
  getMsftWorkspaceId() {
    if (this.usePreProd() || this.isLocalExp) {
      return MSFT_WORKSPACE_ID_LOCAL;
    }
    return MSFT_WORKSPACE_ID_PROD;
  }
  setUser(user) {
    this.config.user = user;
    this.fireEvent(this.onUserChangedCallback);
  }
  /**
   * This is set on load by the RenderExperience
   * based on the workspace information and forceUnifiedView
   * And it will be read throughout the application after initial load.
   */
  setIsUnifiedView(value) {
    this._isUnifiedView = value;
  }
  get isTest() {
    return this.config.test;
  }
  onUserChanged(callback) {
    this.onUserChangedCallback.push(callback);
  }
  setTreatmentVariables(treatmentVariables) {
    return this.config.treatmentVariables = treatmentVariables;
  }
  get treatmentVariables() {
    return !!this.config.treatmentVariables ? this.config.treatmentVariables : defaultTreatmentVariables;
  }
  showSearchNavBar() {
    return !this.useNewSearchExperience() && (!!document.location.pathname.match(/^\/a\/experiment/i) || !!document.location.pathname.match(/^\/a\/CreateExp\/SelectTemplate/i) || !!document.location.pathname.match(/^\/a\/search\/experiments/i) || !!document.location.pathname.match(/^\/a\/search\/myactivities/i) || !!document.location.pathname.match(/^\/a\/feature/i) || document.location.pathname === "/");
  }
  xCardMovePFilters() {
    return defaultTreatmentVariables.xCardMovePFilters;
  }
  xCardResponsiveToggle() {
    return defaultTreatmentVariables.xCardResponsiveToggle;
  }
  scorecardTableOptInLevel() {
    return defaultTreatmentVariables.scorecardTableOptInLevel;
  }
  xCardDisableLegacyTable() {
    return defaultTreatmentVariables.xCardDisableLegacyTable;
  }
  EnableXCardNotebookExtension() {
    return defaultTreatmentVariables.EnableXCardNotebookExtension;
  }
  EnableCatapultReviewExtension() {
    return defaultTreatmentVariables.EnableCatapultReviewExtension;
  }
  EnableEmptyScorecardDebugger() {
    return defaultTreatmentVariables.EnableEmptyScorecardDebugger;
  }
  EnableXBoxGamingExtension() {
    return defaultTreatmentVariables.EnableXBoxGamingExtension;
  }
  EnableAbstractExtension() {
    return defaultTreatmentVariables.EnableAbstractExtension;
  }
  EnableInteractiveDebugging() {
    return defaultTreatmentVariables.EnableInteractiveDebugging;
  }
  EnableMetricPowerExtension() {
    return defaultTreatmentVariables.EnableMetricPowerExtension;
  }
  EnableArenaExtension() {
    return defaultTreatmentVariables.EnableArenaExtension;
  }
  EnableArenaExposure() {
    return defaultTreatmentVariables.EnableArenaExposure;
  }
  EnableTitanQueryParamSlug() {
    return defaultTreatmentVariables.EnableTitanQueryParamSlug;
  }
  EnableEdgeExtension() {
    return defaultTreatmentVariables.EnableEdgeExtension;
  }
  EnableTitanInUTC() {
    return defaultTreatmentVariables.EnableTitanInUTC;
  }
  EnableTitanNativeFilters() {
    return defaultTreatmentVariables.EnableTitanNativeFilters;
  }
  EnablexCardExtension() {
    return defaultTreatmentVariables.EnablexCardExtension;
  }
  EnableXCardTitanExtensionV2() {
    return defaultTreatmentVariables.EnableXCardTitanExtensionV2;
  }
  enableASSelectionInIgManagement() {
    return defaultTreatmentVariables.enableASSelectionInIgManagement;
  }
  waitForPublishSubmissionToLoadStatus() {
    return defaultTreatmentVariables.waitForPublishSubmissionToLoadStatus;
  }
  useXCardThroughFEProxy() {
    return defaultTreatmentVariables.useXCardThroughFEProxy;
  }
  updateArenaText() {
    return defaultTreatmentVariables.updateArenaText;
  }
  redirectAzureExpFeature404s() {
    return defaultTreatmentVariables.redirectAzureExpFeature404s;
  }
  enableAzureExpAutoTriggeringUX() {
    return defaultTreatmentVariables.enableAzureExpAutoTriggeringUX;
  }
  replaceCTSearchView() {
    return defaultTreatmentVariables.replaceCTSearchView;
  }
  optInWsIdToNewFeatureSearch() {
    return defaultTreatmentVariables.optInWsIdToNewFeatureSearch;
  }
  enableClearFiltersButton() {
    return defaultTreatmentVariables.enableClearFiltersButton;
  }
  useRTKQueryFeatureSearch() {
    return defaultTreatmentVariables.useRTKQueryFeatureSearch;
  }
  useOnlyMySubscribedInititialState() {
    return defaultTreatmentVariables.useOnlyMySubscribedInititialState;
  }
  previewScorecardSearchCountLegacy() {
    return defaultTreatmentVariables.previewScorecardSearchCountLegacy;
  }
  previewScorecardSearchCountUnified() {
    return defaultTreatmentVariables.previewScorecardSearchCountUnified;
  }
  enableSubClusterA11yUpdate() {
    return defaultTreatmentVariables.enableSubClusterA11yUpdate;
  }
  useNewFlightListViewer() {
    return defaultTreatmentVariables.useNewFlightListViewer;
  }
  useNewSectionBox() {
    return defaultTreatmentVariables.useNewSectionBox;
  }
  previewScorecardOptinLevel() {
    return defaultTreatmentVariables.previewScorecardOptinLevel;
  }
  previewScorecardOptInDefaultDate() {
    return defaultTreatmentVariables.previewScorecardOptInDefaultDate;
  }
  previewScorecardOptInDeprecatedDate() {
    return defaultTreatmentVariables.previewScorecardOptInDeprecatedDate;
  }
  enableNewPreviewScorecardPage() {
    return defaultTreatmentVariables.enableNewPreviewScorecardPage;
  }
  enableMetricsWizard() {
    return defaultTreatmentVariables.enableMetricsWizard;
  }
  enableMetricsWizardTesting() {
    return defaultTreatmentVariables.enableMetricsWizardTesting;
  }
  enableMetricsWizardFilters() {
    return defaultTreatmentVariables.enableMetricsWizardFilters;
  }
  enableMetricsWizardCustomDim() {
    return defaultTreatmentVariables.enableMetricsWizardCustomDim;
  }
  enableMetricsWizardIfElse() {
    return defaultTreatmentVariables.enableMetricsWizardIfElse;
  }
  disableMetricsWizardExperienceCheck() {
    return defaultTreatmentVariables.disableMetricsWizardExperienceCheck;
  }
  enableMetricsWizardRawMode() {
    return defaultTreatmentVariables.enableMetricsWizardRawMode;
  }
  enableMetricsWizardInternalNameCheck() {
    return defaultTreatmentVariables.enableMetricsWizardInternalNameCheck;
  }
  enableMetricCreationViaTemplate() {
    return defaultTreatmentVariables.enableMetricCreationViaTemplate;
  }
  enableNewCreateCustomColumnView() {
    return defaultTreatmentVariables.enableNewCreateCustomColumnView;
  }
  enableNewCreateCustomColumnViewTesting() {
    return defaultTreatmentVariables.enableNewCreateCustomColumnViewTesting;
  }
  includeCompleteResponseInRestResult() {
    return defaultTreatmentVariables.includeCompleteResponseInRestResult;
  }
  useNewSegmentsUI() {
    return defaultTreatmentVariables.useNewSegmentsUI;
  }
  enableAnalysisCreateSubscriberComponent() {
    return defaultTreatmentVariables.enableAnalysisCreateSubscriberComponent;
  }
  enableTransferWarningConflictFix() {
    return defaultTreatmentVariables.enableTransferWarningConflictFix;
  }
  displayFriendlyValidationMessageForDSMSHistory() {
    return defaultTreatmentVariables.displayFriendlyValidationMessageForDSMSHistory;
  }
  updateTVNameLengthLimit() {
    return defaultTreatmentVariables.updateTVNameLengthLimit;
  }
  useIgDisplayNameExperimentCreate() {
    return defaultTreatmentVariables.useIgDisplayNameExperimentCreate;
  }
  enableSyncedMetricSetPermissionWorkflow() {
    return defaultTreatmentVariables.enableSyncedMetricSetPermissionWorkflow;
  }
  enableSyncedMetricSetCreateWorkflow() {
    return defaultTreatmentVariables.enableSyncedMetricSetCreateWorkflow;
  }
  enableNoStepsInStageFix() {
    return defaultTreatmentVariables.enableNoStepsInStageFix;
  }
  useUpdatedFeatureXCardLink() {
    return defaultTreatmentVariables.useUpdatedFeatureXCardLink;
  }
  enableBudgetPagePriority() {
    return defaultTreatmentVariables.enableBudgetPagePriority;
  }
  enableIsolationGroupManagementPriority() {
    return defaultTreatmentVariables.enableIsolationGroupManagementPriority;
  }
  updateAssignmentInconsistencyForTransfer() {
    return defaultTreatmentVariables.updateAssignmentInconsistencyForTransfer;
  }
  addGroupTemplateSelectFeature() {
    return defaultTreatmentVariables.addGroupTemplateSelectFeature;
  }
  testUpdatedProgressionsCall() {
    return defaultTreatmentVariables.testUpdatedProgressionsCall;
  }
  enableWorkspaceMismatchPage() {
    return defaultTreatmentVariables.enableWorkspaceMismatchPage;
  }
  defaultAutoTriggerState() {
    return defaultTreatmentVariables.defaultAutoTriggerState;
  }
  enableAutoTriggerToggle() {
    return defaultTreatmentVariables.enableAutoTriggerToggle;
  }
  enableTreatmentVariableExperience() {
    return defaultTreatmentVariables.enableTreatmentVariableExperience;
  }
  useNewAddAnalysisPanel() {
    return defaultTreatmentVariables.useNewAddAnalysisPanel;
  }
  enableOverridesTrafficEditV2() {
    return defaultTreatmentVariables.enableOverridesTrafficEditV2;
  }
  enableProgressionStageControlCorrection() {
    return defaultTreatmentVariables.enableProgressionStageControlCorrection;
  }
  enableSRMDebugEnhancements() {
    return defaultTreatmentVariables.enableSRMDebugEnhancements;
  }
  useAPIMVCurrentExpManURL() {
    return defaultTreatmentVariables.useAPIMVCurrentExpManURL;
  }
  a11yProgressionNameTextFieldContrast() {
    return defaultTreatmentVariables.a11yProgressionNameTextFieldContrast;
  }
  vivaceiframeoptinlevel() {
    return defaultTreatmentVariables.vivaceiframeoptinlevel;
  }
  vivaceiframeoptindefaultdate() {
    return defaultTreatmentVariables.vivaceiframeoptindefaultdate;
  }
  vivaceiframeoptindeprecateddate() {
    return defaultTreatmentVariables.vivaceiframeoptindeprecateddate;
  }
  enableMetricSetDelete() {
    return defaultTreatmentVariables.enableMetricSetDelete;
  }
  enableFlashResaltWarning() {
    return defaultTreatmentVariables.enableFlashResaltWarning;
  }
  showAdvanceSearchInUnifiedView() {
    return defaultTreatmentVariables.showAdvanceSearchInUnifiedView;
  }
  useTraditionalFeatureListInUnifiedView() {
    return defaultTreatmentVariables.useTraditionalFeatureListInUnifiedView;
  }
  fixDisableAutoshutdown() {
    return defaultTreatmentVariables.fixDisableAutoshutdown;
  }
  showAdminPortalInUnifiedView() {
    return defaultTreatmentVariables.showAdminPortalInUnifiedView;
  }
  optInWsIdToUnifiedView() {
    return defaultTreatmentVariables.optInWsIdToUnifiedView;
  }
  forceUnifiedView() {
    return defaultTreatmentVariables.forceUnifiedView;
  }
  forceControlTower() {
    return defaultTreatmentVariables.forceControlTower;
  }
  enableStudioFeatureHistory() {
    return defaultTreatmentVariables.enableStudioFeatureHistory;
  }
  allowUnifiedSearchDateFilter() {
    return defaultTreatmentVariables.allowUnifiedSearchDateFilter;
  }
  doNotLoadMSFTWorkspaceData() {
    return defaultTreatmentVariables.doNotLoadMSFTWorkspaceData;
  }
  showDifferentProgressionFeaturesOnVNext() {
    return defaultTreatmentVariables.showDifferentProgressionFeaturesOnVNext;
  }
  showMMPivot() {
    return defaultTreatmentVariables.showMMPivot;
  }
  showFilterbar() {
    return defaultTreatmentVariables.showFilterbar;
  }
  showCIPlot() {
    return defaultTreatmentVariables.showCIPlot;
  }
  parallelSRMWarning() {
    return defaultTreatmentVariables.parallelSRMWarning;
  }
  enableInterleaving() {
    return defaultTreatmentVariables.enableInterleaving;
  }
  disableMsalInPopupLogProvider() {
    return defaultTreatmentVariables.disableMsalInPopupLogProvider;
  }
  logSetUser() {
    return defaultTreatmentVariables.logSetUser;
  }
  enableNewScorecardTemplate() {
    return defaultTreatmentVariables.enableNewScorecardTemplate;
  }
  useProgressionUpdateFormik() {
    return defaultTreatmentVariables.useProgressionUpdateFormik;
  }
  ShowUnifiedStudioAlerts() {
    return defaultTreatmentVariables.ShowUnifiedStudioAlerts;
  }
  SetIFrameUrl() {
    return defaultTreatmentVariables.SetIFrameUrl;
  }
  EnableUnifiedViewIsolationGroupMultiSelection() {
    return defaultTreatmentVariables.EnableUnifiedViewIsolationGroupMultiSelection;
  }
  ShowUnifiedViewReRandomizeCheckBox() {
    return defaultTreatmentVariables.ShowUnifiedViewReRandomizeCheckBox;
  }
  enableBatchAlertsAPICall() {
    return defaultTreatmentVariables.enableBatchAlertsAPICall;
  }
  loadSingleStageAlerts() {
    return defaultTreatmentVariables.loadSingleStageAlerts;
  }
  deprecateLegacyAlertUX() {
    return defaultTreatmentVariables.deprecateLegacyAlertUX;
  }
  deprecatedBctPaths() {
    return defaultTreatmentVariables.deprecatedBctPaths;
  }
  linkRouteActionForSearchMode() {
    return defaultTreatmentVariables.linkRouteActionForSearchMode;
  }
  showDRIHelpResources() {
    var _a;
    return (_a = defaultTreatmentVariables.showDRIHelpResources) != null ? _a : false;
  }
  enableProgressionBulkEdit() {
    return defaultTreatmentVariables.enableProgressionBulkEdit;
  }
  hideLegacyCreateFlightbyMG() {
    return defaultTreatmentVariables.hideLegacyCreateFlightbyMG;
  }
  enableFilterValueValidation() {
    return defaultTreatmentVariables.enableFilterValueValidation;
  }
  enableTreatmentVariableNamespaceEdit() {
    return defaultTreatmentVariables.enableTreatmentVariableNamespaceEdit;
  }
  showBlueshiftCMSUI() {
    return defaultTreatmentVariables.showBlueshiftCMSUI;
  }
  enableHypothesisInStudio() {
    return defaultTreatmentVariables.enableHypothesisInStudio;
  }
  enableAnalysisLinkDropdown() {
    return defaultTreatmentVariables.enableAnalysisLinkDropdown;
  }
  garAnalysisHubLoadAlerts() {
    return defaultTreatmentVariables.garAnalysisHubLoadAlerts;
  }
  garAnalysisHubHideEmptyScorecards() {
    return defaultTreatmentVariables.garAnalysisHubHideEmptyScorecards;
  }
  analysisHubTimeout() {
    return defaultTreatmentVariables.analysisHubTimeout;
  }
  analysisHubPriority() {
    return defaultTreatmentVariables.analysisHubPriority;
  }
  EnableStudyTaskPivot() {
    return defaultTreatmentVariables.EnableStudyTaskPivot;
  }
  xCardLinkIndex() {
    return defaultTreatmentVariables.xCardLinkIndex;
  }
  guidedLinkIndex() {
    return defaultTreatmentVariables.guidedLinkIndex;
  }
  allScorecardsLinkIndex() {
    return defaultTreatmentVariables.allScorecardsLinkIndex;
  }
  xCardLinkString() {
    return defaultTreatmentVariables.xCardLinkString;
  }
  guidedLinkString() {
    return defaultTreatmentVariables.guidedLinkString;
  }
  allScorecardsLinkString() {
    return defaultTreatmentVariables.allScorecardsLinkString;
  }
  wsplitEnableRedirects() {
    return defaultTreatmentVariables.wsplitEnableRedirects;
  }
  wsplitEnableNonMSFTRedirects() {
    return defaultTreatmentVariables.wsplitEnableNonMSFTRedirects;
  }
  wsplitExpManGenericRedirects() {
    return defaultTreatmentVariables.wsplitExpManGenericRedirects;
  }
  wsplitGetMigrationDataByWsid() {
    return defaultTreatmentVariables.wsplitGetMigrationDataByWsid;
  }
  wsplitMigrationEmail() {
    return defaultTreatmentVariables.wsplitMigrationEmail;
  }
  wsplitMigrationDate() {
    return defaultTreatmentVariables.wsplitMigrationDate;
  }
  wsplitPendingMigrationBannerText() {
    return defaultTreatmentVariables.wsplitPendingMigrationBannerText;
  }
  wsplitMigratingBannerText() {
    return defaultTreatmentVariables.wsplitMigratingBannerText;
  }
  wsplitRedirectBannerText() {
    return defaultTreatmentVariables.wsplitRedirectBannerText;
  }
  wsplitMethodNotAllowedText() {
    return defaultTreatmentVariables.wsplitMethodNotAllowedText;
  }
  wsplitNotAcceptableText() {
    return defaultTreatmentVariables.wsplitNotAcceptableText;
  }
  wsplitEnableWSAutoPopulate() {
    return defaultTreatmentVariables.wsplitEnableWSAutoPopulate;
  }
  wsplitDeprecateUsingTid() {
    return defaultTreatmentVariables.wsplitDeprecateUsingTid;
  }
  enableWorkspaceSplitTesting() {
    return defaultTreatmentVariables.enableWorkspaceSplitTesting;
  }
  wsplitReadOnly() {
    return defaultTreatmentVariables.wsplitReadOnly;
  }
  wsplitCannotUpdate() {
    return defaultTreatmentVariables.wsplitCannotUpdate;
  }
  wsplitReturn301() {
    return defaultTreatmentVariables.wsplitReturn301;
  }
  wsplitRedirectWorkspaceId() {
    return defaultTreatmentVariables.wsplitRedirectWorkspaceId;
  }
  useEnv() {
    return defaultTreatmentVariables.useEnv;
  }
  /**
   * Workspace migration - END
   */
  /**
   * OPT-IN flights, need reviw of redirects defined in opt-in configuration
   */
  // feature: https://exp.microsoft.com/a/feature/b14ea179-7ee4-4c0b-974c-02411a868731
  // remove task - https://experimentation.visualstudio.com/Analysis%20and%20Experimentation/_workitems/edit/26808
  analysisTemplateOptInLevel() {
    return 20;
  }
  // feature: https://exp.microsoft.com/a/feature/af6829e4-c3d9-40c1-99d8-651e70acf009
  flightOptInLevel() {
    return 20;
  }
  // feature: https://exp.microsoft.com/a/feature/f30381c2-4c97-4dda-b986-9cc1cdb12724
  createFlightOptInLevel() {
    return 20;
  }
  // feature: https://exp.microsoft.com/a/feature/7e9779e4-f746-47e8-adf6-0b6c1cb29a61
  experimentCreateOptInLevel() {
    return 20;
  }
  // feature: https://exp.microsoft.com/a/feature/c2474e13-084a-4adb-a4e2-8a4b80ed2a2f
  // A&E only since 4/9/2020
  experimentOptInLevel() {
    return 20;
  }
  // feature: https://exp.microsoft.com/a/feature/97ff55f1-fb61-4008-bb45-eb31c03cb6db
  // A&E Only - since 3/26/2020
  optInLevelNewAnalysisPage() {
    return 20;
  }
  // feature: https://exp.microsoft.com/a/feature/ebd42863-1e8c-46e9-bfaf-2d2ed133bc14?workspaceId=a5766fee-9478-488b-9fc0-64d1ad72c290
  // Owner: bsera, created on 7/18/2020
  // remove:
  optInLevelNewAnalysisCreate() {
    return 20;
  }
  // feature: https://exp.microsoft.com/a/feature/7dc37229-d543-4292-b5ad-1c6386bc574d?workspaceId=a5766fee-9478-488b-9fc0-64d1ad72c290
  // Owner: bsera, created on 7/18/2020
  // remove:
  optInLevelNewAnalysisClone() {
    return 20;
  }
  // feature: https://exp.microsoft.com/a/feature/99e1a673-c570-4d34-8f4d-d50c70411209
  // Owner: bryw create 9/2
  // remove:
  resolveGateOptInLevel() {
    return 20;
  }
  // feature: https://exp.microsoft.com/a/feature/e7241cb2-e3e3-4b01-8d54-5fad65497f46
  // Toggles new budget search experience.
  budgetSearchOptIn() {
    return 20;
  }
  // feature: https://exp.microsoft.com/a/feature/6d2c4a87-8b6c-4423-acb4-7463b5308d59
  // Toggle for new emergency shutdown page.
  emergencyShutdownOptIn() {
    return 20;
  }
  releaseDSMSdataprofiling() {
    return defaultTreatmentVariables.releaseDSMSdataprofiling;
  }
  enableNewEnvFlag() {
    return defaultTreatmentVariables.enableNewEnvFlag;
  }
  enableCMSUnifiedApi() {
    return defaultTreatmentVariables.enableCMSUnifiedApi;
  }
  fixLayoutScrollbars() {
    return defaultTreatmentVariables.fixLayoutScrollbars;
  }
  enableRefactoredWSSelection() {
    return defaultTreatmentVariables.enableRefactoredWSSelection;
  }
  enableVCurrentWPS() {
    return defaultTreatmentVariables.enableVCurrentWPS;
  }
  enableAAStream() {
    return defaultTreatmentVariables.enableAAStream;
  }
  useWPSProxy() {
    return defaultTreatmentVariables.useWPSProxy;
  }
  enableBlueShiftOverride() {
    return defaultTreatmentVariables.enableBlueShiftOverride;
  }
  enableHelpMessageBar() {
    return defaultTreatmentVariables.enableHelpMessageBar;
  }
  enableHelpImagePreview() {
    return defaultTreatmentVariables.enableHelpImagePreview;
  }
  enableIsolationGroupManagement() {
    return defaultTreatmentVariables.enableIsolationGroupManagement;
  }
  enableExPCopilot() {
    return defaultTreatmentVariables.enableExPCopilot;
  }
  getGatingTenantFromMigrationRecord() {
    return defaultTreatmentVariables.getGatingTenantFromMigrationRecord;
  }
  enableExPCopilotHelpPageOnly() {
    return defaultTreatmentVariables.enableExPCopilotHelpPageOnly;
  }
  openFeatureInSameTab() {
    return defaultTreatmentVariables.openFeatureInSameTab;
  }
  enableRequiredMDSFiltersValidation() {
    return defaultTreatmentVariables.enableRequiredMDSFiltersValidation;
  }
  showAssignmentUnitId() {
    return defaultTreatmentVariables.showAssignmentUnitId;
  }
  enableUnifiedAPIOfSubscribeMode() {
    return defaultTreatmentVariables.enableUnifiedAPIOfSubscribeMode;
  }
  filterNonCompatMgsFromSearch() {
    return defaultTreatmentVariables.filterNonCompatMgsFromSearch;
  }
  useCMSThroughFEProxy() {
    return defaultTreatmentVariables.useCMSThroughFEProxy;
  }
  useNewMergeErrorPanel() {
    return defaultTreatmentVariables.useNewMergeErrorPanel;
  }
  enableProgressionTemplates() {
    return defaultTreatmentVariables.enableProgressionTemplates;
  }
  disableLegacyProgressionCreateInStudio() {
    return defaultTreatmentVariables.disableLegacyProgressionCreateInStudio;
  }
  enableHypothesisTemplateFiltering() {
    return defaultTreatmentVariables.enableHypothesisTemplateFiltering;
  }
  enableUnifiedNoCacheMiddleware() {
    return defaultTreatmentVariables.enableUnifiedNoCacheMiddleware;
  }
  enableEgSelectionInAuManagement() {
    return defaultTreatmentVariables.enableEgSelectionInAuManagement;
  }
  enableEgSelectionInIgManagement() {
    return defaultTreatmentVariables.enableEgSelectionInIgManagement;
  }
  enableMSIForCMS() {
    return defaultTreatmentVariables.enableMSIForCMS;
  }
  enableMSIForDSMS() {
    return defaultTreatmentVariables.enableMSIForDSMS;
  }
  useMgFormatInOperationCheckMarkdown() {
    return defaultTreatmentVariables.useMgFormatInOperationCheckMarkdown;
  }
  enableEgSelectionInAfManagement() {
    return defaultTreatmentVariables.enableEgSelectionInAfManagement;
  }
  enableSampleDataSource() {
    return defaultTreatmentVariables.enableSampleDataSource;
  }
  enableNewMDLPollingPolicy() {
    return defaultTreatmentVariables.enableNewMDLPollingPolicy;
  }
  quickValidateMetricsetAllowList() {
    return defaultTreatmentVariables.quickValidateMetricsetAllowList;
  }
  enableMoreColumnsOnFeatureListPage() {
    return defaultTreatmentVariables.enableMoreColumnsOnFeatureListPage;
  }
  useFalseForOnlyLoadFeatureData() {
    return defaultTreatmentVariables.useFalseForOnlyLoadFeatureData;
  }
  callXCardApiCommonInfra() {
    return defaultTreatmentVariables.callXCardApiCommonInfra;
  }
  EnableQuickValidationByWorkspace() {
    return defaultTreatmentVariables.EnableQuickValidationByWorkspace;
  }
  enableTimeZoneFeature() {
    return defaultTreatmentVariables.enableTimeZoneFeature;
  }
  useLatestUnifiedApiVersion() {
    return defaultTreatmentVariables.useLatestUnifiedApiVersion;
  }
  enableProgressionStageAlertImprovements() {
    return defaultTreatmentVariables.enableProgressionStageAlertImprovements;
  }
  enableMergePublishTimeout() {
    return defaultTreatmentVariables.enableMergePublishTimeout;
  }
  showDetailedTaskState() {
    return defaultTreatmentVariables.showDetailedTaskState;
  }
  disableCreateAnalysisOnDataCollection() {
    return defaultTreatmentVariables.disableCreateAnalysisOnDataCollection;
  }
  enableExperimentationGroupLevelPermissions() {
    return defaultTreatmentVariables.enableExperimentationGroupLevelPermissions;
  }
  enableIApiErrorExceptionHandlingToCT() {
    return defaultTreatmentVariables.enableIApiErrorExceptionHandlingToCT;
  }
  enableAnalysisTemplateVersionLinkFix() {
    return defaultTreatmentVariables.enableAnalysisTemplateVersionLinkFix;
  }
  enableShadowExperiment() {
    return defaultTreatmentVariables.enableShadowExperiment;
  }
  enableStudioAssignmentInconsistency() {
    return defaultTreatmentVariables.enableStudioAssignmentInconsistency;
  }
  excludeFeatureTypeFromMetadataQuery() {
    return defaultTreatmentVariables.excludeFeatureTypeFromMetadataQuery;
  }
  useNewSearchExperience(workspaceId = this.getWorkspaceIdOrDefault()) {
    if (this.replaceCTSearchView()) {
      return true;
    }
    if (!workspaceId) {
      return false;
    }
    try {
      const wsids = this.optInWsIdToNewFeatureSearch().split(",").map((wsid) => wsid.trim().toLocaleLowerCase());
      return wsids.includes(workspaceId.toLocaleLowerCase());
    } catch (e) {
      console.error("Error in useNewSearchExperience", e);
      return false;
    }
  }
  /**
   * END OPT-IN flights
   */
  usePreProd() {
    const ppeQs = this.getQueryParam(PREPROD_ENVIRONMENT);
    const isPpeUiHost = document.location.hostname.match(/^ppe/);
    return ppeQs === void 0 ? !!isPpeUiHost : ppeQs === "true";
  }
  showFlightSearchNavBar() {
    return !!document.location.pathname.match(/^\/a\/search\/flights/i) || !!document.location.pathname.match(/^\/a\/flight/i) || !!document.location.pathname.match(/^\/a\/emergency-shutdown/i);
  }
  get assetUrl() {
    return this.config.assetUrl;
  }
  /**
   * Get the current CDN path either the latest version, a specified version or version that corresponds with a branch
   * The deploy gulp task for publishing to the CDN provides a .txt file with the corresponding version number
   */
  getAssetUrl() {
    return __async(this, null, function* () {
      let url = null;
      let branchName = this.getQueryParam(BRANCH_NAME_FIELD);
      let baseUrl = this.getQueryParam(BASE_URL_FIELD);
      let version = this.getQueryParam(VERSION_FIELD) || "";
      const origin = window.location.origin;
      if (!!version) {
        const customBuild = this.getQueryParam(BST_CUSTOM_BUILD);
        version = !!customBuild ? `${version}/${customBuild}` : version;
        url = `${ROOT_BLOB_ASSET_URL}/assets/${version}/`;
      }
      if (!!baseUrl && !url) {
        url = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
      }
      if (!!branchName && !url) {
        const cleanBranchName = branchName.replace(/refs\/heads\//, "").replace(/[/\\*?:"<>|]/g, "_");
        version = yield $.ajax(`${ROOT_BLOB_ASSET_URL}/assets/private/package-version-${cleanBranchName}.txt`, {
          cache: false
        });
        const customBuild = this.getQueryParam(BST_CUSTOM_BUILD);
        version = !!customBuild ? `${version}/${customBuild}` : version;
        url = `${ROOT_BLOB_ASSET_URL}/assets/private/${version}/`;
      }
      const windowExpUxVersion = HostService.expUxVersion;
      if (windowExpUxVersion) {
        version = windowExpUxVersion;
        url = HostService.expUxCndAssetUrl;
        this.config.isPreRelease = false;
      }
      if (window.location.origin === LOCAL_ORIGIN && !url) {
        url = `${origin}/`;
        version = origin;
      }
      if (!this.isLocal && !url) {
        version = yield fetch(`${ROOT_BLOB_ASSET_URL}/assets/package-version.txt`, {
          cache: "no-cache",
          retryDelay: 500,
          // @ts-ignore
          retryOn: (attempt, error, response) => {
            const { status = 0 } = response || {};
            const { message = "" } = error || {};
            if (error !== null || status >= 400) {
              if (attempt <= 2) {
                return true;
              } else {
                const $loadingDots = jQuery(".fxs-splashscreen-loader-container");
                const $error = jQuery("#ane-loader-error");
                jQuery("#ane-loader-error").find("a").attr("href", `mailto:mb2ctdri@microsoft.com?subject=Error loading CT&body=${message}

`);
                $loadingDots.hide();
                $error.show();
                if (!!message) {
                  $error.append(`<h3>Details</h3><p>${message}</p>`);
                }
                try {
                  throw error;
                } catch (e) {
                  throw Error(
                    `Loader: maximum number of retries reached attempting to fetch current package version. Attempt: ${attempt}, Response: ${response}`
                  );
                }
              }
            }
          }
        }).then(function(response) {
          return response.text();
        });
        const customBuild = this.getQueryParam(BST_CUSTOM_BUILD);
        version = !!customBuild ? `${version}/${customBuild}` : version;
        url = `${HostService.expUxCdnHost}/${version}/`;
        this.config.isPreRelease = false;
      }
      this.config.version = version;
      if (!url) {
        url = `${document.location.protocol}//${document.location.host}/${version}/`;
      }
      this.config.assetUrl = url;
      return url;
    });
  }
  fireEvent(event) {
    this.onUserChangedCallback.forEach((c) => {
      c();
    });
  }
}
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "xCardMovePFilters", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "xCardResponsiveToggle", 1);
__decorateClass([
  treatmentVariable("number")
], EnvironmentService.prototype, "scorecardTableOptInLevel", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "xCardDisableLegacyTable", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "EnableXCardNotebookExtension", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "EnableCatapultReviewExtension", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "EnableEmptyScorecardDebugger", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "EnableXBoxGamingExtension", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "EnableAbstractExtension", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "EnableInteractiveDebugging", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "EnableMetricPowerExtension", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "EnableArenaExtension", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "EnableArenaExposure", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "EnableTitanQueryParamSlug", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "EnableEdgeExtension", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "EnableTitanInUTC", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "EnableTitanNativeFilters", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "EnablexCardExtension", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "EnableXCardTitanExtensionV2", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableASSelectionInIgManagement", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "waitForPublishSubmissionToLoadStatus", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "useXCardThroughFEProxy", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "updateArenaText", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "redirectAzureExpFeature404s", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableAzureExpAutoTriggeringUX", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "replaceCTSearchView", 1);
__decorateClass([
  treatmentVariable("string")
], EnvironmentService.prototype, "optInWsIdToNewFeatureSearch", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableClearFiltersButton", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "useRTKQueryFeatureSearch", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "useOnlyMySubscribedInititialState", 1);
__decorateClass([
  treatmentVariable("number")
], EnvironmentService.prototype, "previewScorecardSearchCountLegacy", 1);
__decorateClass([
  treatmentVariable("number")
], EnvironmentService.prototype, "previewScorecardSearchCountUnified", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableSubClusterA11yUpdate", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "useNewFlightListViewer", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "useNewSectionBox", 1);
__decorateClass([
  treatmentVariable("number")
], EnvironmentService.prototype, "previewScorecardOptinLevel", 1);
__decorateClass([
  treatmentVariable("string")
], EnvironmentService.prototype, "previewScorecardOptInDefaultDate", 1);
__decorateClass([
  treatmentVariable("string")
], EnvironmentService.prototype, "previewScorecardOptInDeprecatedDate", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableNewPreviewScorecardPage", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableMetricsWizard", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableMetricsWizardTesting", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableMetricsWizardFilters", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableMetricsWizardCustomDim", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableMetricsWizardIfElse", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "disableMetricsWizardExperienceCheck", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableMetricsWizardRawMode", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableMetricsWizardInternalNameCheck", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableMetricCreationViaTemplate", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableNewCreateCustomColumnView", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableNewCreateCustomColumnViewTesting", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "includeCompleteResponseInRestResult", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "useNewSegmentsUI", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableAnalysisCreateSubscriberComponent", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableTransferWarningConflictFix", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "displayFriendlyValidationMessageForDSMSHistory", 1);
__decorateClass([
  treatmentVariable("number")
], EnvironmentService.prototype, "updateTVNameLengthLimit", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "useIgDisplayNameExperimentCreate", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableSyncedMetricSetPermissionWorkflow", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableSyncedMetricSetCreateWorkflow", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableNoStepsInStageFix", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "useUpdatedFeatureXCardLink", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableBudgetPagePriority", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableIsolationGroupManagementPriority", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "updateAssignmentInconsistencyForTransfer", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "addGroupTemplateSelectFeature", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "testUpdatedProgressionsCall", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableWorkspaceMismatchPage", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "defaultAutoTriggerState", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableAutoTriggerToggle", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableTreatmentVariableExperience", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "useNewAddAnalysisPanel", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableOverridesTrafficEditV2", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableProgressionStageControlCorrection", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableSRMDebugEnhancements", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "useAPIMVCurrentExpManURL", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "a11yProgressionNameTextFieldContrast", 1);
__decorateClass([
  treatmentVariable("number")
], EnvironmentService.prototype, "vivaceiframeoptinlevel", 1);
__decorateClass([
  treatmentVariable("string")
], EnvironmentService.prototype, "vivaceiframeoptindefaultdate", 1);
__decorateClass([
  treatmentVariable("string")
], EnvironmentService.prototype, "vivaceiframeoptindeprecateddate", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableMetricSetDelete", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableFlashResaltWarning", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "showAdvanceSearchInUnifiedView", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "useTraditionalFeatureListInUnifiedView", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "fixDisableAutoshutdown", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "showAdminPortalInUnifiedView", 1);
__decorateClass([
  treatmentVariable("string")
], EnvironmentService.prototype, "optInWsIdToUnifiedView", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "forceUnifiedView", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "forceControlTower", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableStudioFeatureHistory", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "allowUnifiedSearchDateFilter", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "doNotLoadMSFTWorkspaceData", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "showDifferentProgressionFeaturesOnVNext", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "showMMPivot", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "showFilterbar", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "showCIPlot", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "parallelSRMWarning", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableInterleaving", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "disableMsalInPopupLogProvider", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "logSetUser", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableNewScorecardTemplate", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "useProgressionUpdateFormik", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "ShowUnifiedStudioAlerts", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "SetIFrameUrl", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "EnableUnifiedViewIsolationGroupMultiSelection", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "ShowUnifiedViewReRandomizeCheckBox", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableBatchAlertsAPICall", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "loadSingleStageAlerts", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "deprecateLegacyAlertUX", 1);
__decorateClass([
  treatmentVariable("string")
], EnvironmentService.prototype, "deprecatedBctPaths", 1);
__decorateClass([
  treatmentVariable("string")
], EnvironmentService.prototype, "linkRouteActionForSearchMode", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "showDRIHelpResources", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableProgressionBulkEdit", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "hideLegacyCreateFlightbyMG", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableFilterValueValidation", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableTreatmentVariableNamespaceEdit", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "showBlueshiftCMSUI", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableHypothesisInStudio", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableAnalysisLinkDropdown", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "garAnalysisHubLoadAlerts", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "garAnalysisHubHideEmptyScorecards", 1);
__decorateClass([
  treatmentVariable("number")
], EnvironmentService.prototype, "analysisHubTimeout", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "analysisHubPriority", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "EnableStudyTaskPivot", 1);
__decorateClass([
  treatmentVariable("number")
], EnvironmentService.prototype, "xCardLinkIndex", 1);
__decorateClass([
  treatmentVariable("number")
], EnvironmentService.prototype, "guidedLinkIndex", 1);
__decorateClass([
  treatmentVariable("number")
], EnvironmentService.prototype, "allScorecardsLinkIndex", 1);
__decorateClass([
  treatmentVariable("string")
], EnvironmentService.prototype, "xCardLinkString", 1);
__decorateClass([
  treatmentVariable("string")
], EnvironmentService.prototype, "guidedLinkString", 1);
__decorateClass([
  treatmentVariable("string")
], EnvironmentService.prototype, "allScorecardsLinkString", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "wsplitEnableRedirects", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "wsplitEnableNonMSFTRedirects", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "wsplitExpManGenericRedirects", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "wsplitGetMigrationDataByWsid", 1);
__decorateClass([
  treatmentVariable("string")
], EnvironmentService.prototype, "wsplitMigrationEmail", 1);
__decorateClass([
  treatmentVariable("string")
], EnvironmentService.prototype, "wsplitMigrationDate", 1);
__decorateClass([
  treatmentVariable("string")
], EnvironmentService.prototype, "wsplitPendingMigrationBannerText", 1);
__decorateClass([
  treatmentVariable("string")
], EnvironmentService.prototype, "wsplitMigratingBannerText", 1);
__decorateClass([
  treatmentVariable("string")
], EnvironmentService.prototype, "wsplitRedirectBannerText", 1);
__decorateClass([
  treatmentVariable("string")
], EnvironmentService.prototype, "wsplitMethodNotAllowedText", 1);
__decorateClass([
  treatmentVariable("string")
], EnvironmentService.prototype, "wsplitNotAcceptableText", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "wsplitEnableWSAutoPopulate", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "wsplitDeprecateUsingTid", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableWorkspaceSplitTesting", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "wsplitReadOnly", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "wsplitCannotUpdate", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "wsplitReturn301", 1);
__decorateClass([
  treatmentVariable("string")
], EnvironmentService.prototype, "wsplitRedirectWorkspaceId", 1);
__decorateClass([
  treatmentVariable("string")
], EnvironmentService.prototype, "useEnv", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "releaseDSMSdataprofiling", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableNewEnvFlag", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableCMSUnifiedApi", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "fixLayoutScrollbars", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableRefactoredWSSelection", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableVCurrentWPS", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableAAStream", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "useWPSProxy", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableBlueShiftOverride", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableHelpMessageBar", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableHelpImagePreview", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableIsolationGroupManagement", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableExPCopilot", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "getGatingTenantFromMigrationRecord", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableExPCopilotHelpPageOnly", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "openFeatureInSameTab", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableRequiredMDSFiltersValidation", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "showAssignmentUnitId", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableUnifiedAPIOfSubscribeMode", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "filterNonCompatMgsFromSearch", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "useCMSThroughFEProxy", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "useNewMergeErrorPanel", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableProgressionTemplates", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "disableLegacyProgressionCreateInStudio", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableHypothesisTemplateFiltering", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableUnifiedNoCacheMiddleware", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableEgSelectionInAuManagement", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableEgSelectionInIgManagement", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableMSIForCMS", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableMSIForDSMS", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "useMgFormatInOperationCheckMarkdown", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableEgSelectionInAfManagement", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableSampleDataSource", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableNewMDLPollingPolicy", 1);
__decorateClass([
  treatmentVariable("string")
], EnvironmentService.prototype, "quickValidateMetricsetAllowList", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableMoreColumnsOnFeatureListPage", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "useFalseForOnlyLoadFeatureData", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "callXCardApiCommonInfra", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "EnableQuickValidationByWorkspace", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableTimeZoneFeature", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "useLatestUnifiedApiVersion", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableProgressionStageAlertImprovements", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableMergePublishTimeout", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "showDetailedTaskState", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "disableCreateAnalysisOnDataCollection", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableExperimentationGroupLevelPermissions", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableIApiErrorExceptionHandlingToCT", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableAnalysisTemplateVersionLinkFix", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableShadowExperiment", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "enableStudioAssignmentInconsistency", 1);
__decorateClass([
  treatmentVariable("boolean")
], EnvironmentService.prototype, "excludeFeatureTypeFromMetadataQuery", 1);
const EnvironmentService$1 = new EnvironmentService();
export {
  AZUREEXPROLLOUTOPTINLEVEL,
  AZURE_NEW_TEST_WORKSPACE_ID,
  AZURE_TEST_WORKSPACE_ID,
  METRICSAUTHORINGOPTINLEVEL,
  MSFT_EG_ROOT,
  MSFT_NEW_WORKSPACE_ID_LOCAL,
  MSFT_NEW_WORKSPACE_NAME_LOCAL,
  MSFT_SUBSCRIPTION_ID_PROD,
  MSFT_WORKSPACE_ID_A11YVCURRENT,
  MSFT_WORKSPACE_ID_LOCAL,
  MSFT_WORKSPACE_ID_PROD,
  MSFT_WORKSPACE_NAME_LOCAL,
  MSFT_WORKSPACE_NAME_PROD,
  OPG_WORKSPACE_ID,
  PREVIEWSCORECARDOPTINLEVEL,
  ROOT_BLOB_ASSET_URL,
  EnvironmentService$1 as default,
  defaultTreatmentVariables
};
//# sourceMappingURL=EnvironmentService.js.map
